import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import useIsMobile from 'lib/useIsMobile';

import MuiDialog from './Dialog';

const Dialog = ({ bodyStyle, contentStyle, ...props }) => {
  const mobile = useIsMobile();
  return (
    <MuiDialog
      {...props}
      autoScrollBodyContent
      bodyStyle={useMemo(
        () => ({
          padding: 0,
          ...bodyStyle,
        }),
        [bodyStyle],
      )}
      contentStyle={useMemo(
        () => ({
          maxWidth: mobile
            ? 400
            : 600,
          width: mobile
            ? '90%'
            : 'auto',
          ...contentStyle,
        }),
        [
          contentStyle,
          mobile,
        ],
      )}
    />
  );
};

Dialog.propTypes = {
  ...MuiDialog.propTypes,
  bodyStyle: PropTypes.object,
  contentStyle: PropTypes.object,
};

export default Dialog;
